import React from 'react';
import classnames from 'classnames';
import CategoryLink from 'components/categoryLink';
import { HoverableImageBackground } from 'scy/Background';
import { Title } from 'scy/text';
import { flex, centerItems, centerContent } from 'scy/flex.mod.scss';
import styles from './styles.mod.scss';

export default function CategoryTile({
  category,
  linkClassName,
  backgroundClassName
}) {
  const { name, tag, url } = category;
  const key = name.toLowerCase();
  return (
    <CategoryLink key={key} tag={tag} url={url} className={linkClassName}>
      <HoverableImageBackground
        className={classnames(
          styles[key],
          flex,
          centerItems,
          centerContent,
          backgroundClassName
        )}
      >
        <Title>{name}</Title>
      </HoverableImageBackground>
    </CategoryLink>
  );
}
